import { AxiosResponse } from 'axios'
import { axios } from 'src/api'
import { ApiFetchUsersResponse } from './users.types'

export const apiFetchUsers = async (userToken: string, serverPath: string) => {
  const response: AxiosResponse<ApiFetchUsersResponse> = await axios.post(
    `https://${serverPath}/sialdPMS/web/resourcescrossorigin/user`,
    {
      userToken
    }
  )
  return response
}
